<template>
    <div class="DateTimePickerHeader">
        <BaseNavigationButton :class-name="'DateTimePickerHeader__back'"
                              :icon="'icon-left'"
                              @click="hide()" />

        <div class="navigation-bar__title DateTimePickerHeader__title">
            {{translate(title)}}
        </div>

        <BaseButton :label="'COMMON__OK'"
                    :class-name="'DateTimePickerHeader__ok'"
                    :accent="true"
                    @click="ok()" />
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import BaseButton from './../BaseButton.vue';
    import BaseNavigationButton from './../BaseNavigationButton.vue';

    export default {
        name: 'DateTimePickerHeader',
        components: {
            BaseButton,
            BaseNavigationButton
        },
        computed: {
            ...mapState({
                title: s => s.dateTimePicker.title
            })
        },
        methods: {
            ...mapActions({
                hide: 'dateTimePicker/hide',
                ok: 'dateTimePicker/ok'
            })
        }
    };
</script>


<style>
    .DateTimePickerHeader {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        background-color: #546E7A;
        padding: 8px;
        box-shadow: 0 2px 6px 0 rgba(0,0,0,.14);
        color: #fff;
        margin: 0;
        line-height: 2rem
    }

    .DateTimePickerHeader__back {
        display: none;
        margin-right: 16px;
    }

    .DateTimePickerHeader__ok {
        display: none;
        min-width: 0;
        padding: 0 12px;
    }

    .DateTimePickerHeader__title {
        text-align: center;
        flex: 1 1 auto;
        font-size: 1.25rem;
        -webkit-font-smoothing: antialiased;
        font-weight: 500;
        letter-spacing: .02em;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    @media (max-width: 600px) {
        .DateTimePickerHeader__title {
            text-align: left;
        }

        .DateTimePickerHeader__back {
            display: block;
        }

        .DateTimePickerHeader__ok {
            display: block;
        }
    }
</style>



// WEBPACK FOOTER //
// DateTimePickerHeader.vue?7dbc01a9